import React from 'react';
import ImageOne from '../../images/Powder Coating/powdercoatedthree.jpg';
import ImageTwo from '../../images/car/car-eleven.jpg';
import ImageThree from '../../images/Struk-steel/four.jpg';

const imageData = [
  {
    id: 1,
    image: ImageOne,
    title: "POWDER COATING",
    description:
      "AKT offers professional car detailing services to clean, polish, and protect your vehicle, restoring its shine and freshness using premium products and techniques.",
  },
  {
    id: 2,
    image: ImageTwo,
    title: "CAR CARE",
    description:
      "AKT offers premium windshield protection film that absorbs road impacts, helping prevent chips, cracks, and pitting for safer, longer-lasting clarity.",
  },
  {
    id: 3,
    image: ImageThree,
    title: "STEEL STRUCTURE",
    description:
     "AKT’s interior detailing service provides deep cleaning of seats, carpets, and surfaces, using top-grade products for a spotless and hygienic car interior.",
  },
];

function ImageRow() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 md:h-[600px]">
  {imageData.map((item) => (
    <div key={item.id} className="relative w-full overflow-hidden rounded-xl shadow-lg">
      <img
        src={item.image}
        alt={item.title}
        className="w-full h-full object-fill absolute top-0 left-0 transition-opacity duration-500 bg-white"
      />
      <div className="absolute inset-0 bg-transparent" />
      <div className="absolute bottom-0 left-0 w-full p-6">
        <div className="text-white text-left p-6">
          <h2
            className="text-2xl sm:text-3xl font-bold tracking-wide mb-3"
            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
          >
            {item.title}
          </h2>
          <p className="text-base sm:text-lg">{item.description}</p>
        </div>
      </div>
    </div>
      ))}
    </div>
  );
}

export default ImageRow;
